import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Blog = async () => {
  try {
    return await getData(`/website/blog/blog`);
  } catch (error) {
    console.log(error);
  }
};


export const BlogById = async (id) => {
  try {
    return await getData(`/website/blog/blog/${id}`);
  } catch (error) {
    console.log(error);
  }
};
